import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { addTrailingSlash, parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import { JOB_TYPES } from '@sonifi/wb-admin/constants/wbAdminConstants';

export const getLatestJob = async (timelineUri) => {
  try {
    const jobParams = {
      targets__contains: addTrailingSlash(timelineUri),
      type: JOB_TYPES.PUBLISH_SINGLE_CHANNEL,
      rpp: 1,
      _order_by: '-created',
    };
    const jobRes = await apiService.get(
      `${ENDPOINTS.JOBS}?${parseQueryParams(jobParams)}`,
    );
    const job = jobRes.data?.objects[0] || null;
    const latestJob = job?.created
      ? job
      : {
          created: new Date(8640000000000000).toDateString(), // MAX_DATE
        };

    return latestJob;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createTimelineJob = (channelUri) => {
  const body = {
    type: JOB_TYPES.PUBLISH_SINGLE_CHANNEL,
    targets: [channelUri],
  };
  return apiService.post(ENDPOINTS.JOBS, body);
};
